import type { VueOptions } from './vueOptions';

export type NuxtOptions = Omit<VueOptions, 'app'>;
